import React, { useRef } from 'react';
/** lib, const **/
import classNames from 'classnames';
import { Link, useLocation } from 'react-router-dom';
import { useInViewFadeUp, useInViewFadeIn } from 'lib/use-in-view';
import { SERVICE_NAME } from '../../const';
/** components **/
import { FadeUp, ParallaxItem } from 'components/organisms';
import { ReactComponent as GreenCircleArrow } from 'assets/images/green-circle-arrow.svg';
/** styles **/
import s from '../../styles/organisms/possible-Items.module.scss';
import BgLogo from 'assets/images/bg-logo.svg';

export const PossibleItems: React.FC = () => {
  const location = useLocation();
  const isTopPage = location.pathname === '/';
  const inViewRef1 = useRef<HTMLHeadingElement>(null);
  const inViewRef2 = useRef<HTMLHeadingElement>(null);
  const inViewRef3 = useRef<HTMLHeadingElement>(null);
  const inViewRef4 = useRef<HTMLHeadingElement>(null);
  const inViewRef5 = useRef<HTMLHeadingElement>(null);
  useInViewFadeUp([inViewRef1, inViewRef3, inViewRef4, inViewRef5]);
  useInViewFadeIn([inViewRef2]);
  return (
    <FadeUp>
      <div className={s.possibleItemsWrapper}>
        <h3 className={classNames(s.beforeFadeUp, s.mainFeatureTitle)} ref={inViewRef1}>
          ペットライフ<br className={s.spOnly} />サポートのある<br className={s.spOnly} />マンションなら安心
        </h3>
        <p className={s.conciergeText}>
          <span>まるで"ペットのコンシェルジュ"</span><br />
          <span>マンションの1階に</span>
        </p>
        <div className={s.imagesRow}>
          <img className={s.image01} src={require('assets/images/feature01.png')} alt={SERVICE_NAME} />
          <img className={classNames(s.image02)} src={require('assets/images/feature02.png')} alt={SERVICE_NAME} />
        </div>
        <div className={classNames(s.beforeFadeIn, s.inner)} ref={inViewRef2}>

          <p className={s.leadText}>
            ペットのコンシェルジュ <span>×</span> 互助コミュニティ
          </p>
          <div className={s.row}>
            <div className={classNames(s.beforeFadeUp, s.item)} ref={inViewRef3}>
              <h3>いっぱい使える!</h3>
              <p>
                <span>ペットシッター・犬の保育園も気軽に使える！</span>仕事が忙しい方も安心。保育園送迎も入居者特典でラクチン＆クイックに！
              </p>
            </div>
            <div className={classNames(s.beforeFadeUp, s.delay01, s.item)} ref={inViewRef4}>
              <h3>いつでも使える!</h3>
              <p>
                いざという時も、ちょっと⾒守って欲しい時も、<span>頼れる味⽅がいっぱい！</span>
                <br />
                ペットシッターなどの専門家はもちろん、飼い主同士のつながりがあるのも安心。
              </p>
            </div>
            <div className={classNames(s.beforeFadeUp, s.delay02, s.item)} ref={inViewRef5}>
              <h3>いつまでも使える!</h3>
              <p>
                ペットが⽼齢や病気になっても、安⼼できる<span>慣れ親しんだ環境でずっと</span>過ごせる。
                <br />
                ペットシッター対応つきなら移動にも負担がかかりません。
              </p>
            </div>
          </div>
          {isTopPage && (
            <div className={s.bottomBlock}>
              <p className={s.bottomText}>
                真の“ペットと人の共生”<br className={s.spOnly} />マンションを目指し、<br />
                三菱地所が事業化を検討中です
              </p>
              <Link className={s.bottomMoreLink} to="/about">
                <p>もっとみる</p>
                <GreenCircleArrow className={s.moreLinkIcon} />
              </Link>
            </div>
          )}
        </div>
        <ParallaxItem className={s.parallaxBg}>
          <img src={BgLogo} alt={SERVICE_NAME} />
        </ParallaxItem>
      </div>
    </FadeUp>
  );
};
